
const __default__ = {
  props: {
    max_width: {
      type: String,
      default: '50%'
    },
    min_width: {
      type: String,
      default: '30em'
    },
    max_height: {
      type: String,
      default: '90%'
    },
    segment: {
      type: String,
      default: undefined
    },
    centered: {
      type: Boolean,
      default: true
    },
    maskTo: {
      type: [String, Object],
      default: '#modals'
    },
    modalTo: {
      type: [String, Object],
      default: '#modals'
    },
    dialogClass: {
      type: String,
      default: undefined
    },
    blur: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click-outside', 'after-leave', 'after-enter'],
  data() {
    return {
      show: false,
    }
  },
  computed: {
    content_style() {
      let style = {
        'background-color': 'var(--base-white)',
      }
      if (this.max_width) {
        style['max-width'] = this.max_width
      }
      if (this.min_width) {
        style['min-width'] = this.min_width
      }
      if (this.max_height) {
        style['max-height'] = this.max_height
      }
      return style
    },
    ctrls_justify() {
      return this.centered ? 'center' : 'flex-end'
    },
    id() {
      return Math.random()
    }
  },
  methods: {
    close () {
      this.show = false
    },
    open () {
      this.show = true
    },
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "d9807fa6-ctrls_justify": (_ctx.ctrls_justify)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__